var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"est-calc-container",class:_vm.isGreen ? 'green' : ''},[_c('div',{staticClass:"est-calc-inner"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }